import {
  Component,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Cropper from 'cropperjs';
import { NgxImageCompressService } from 'ngx-image-compress';

@Component({
  selector: 'app-image-cropper-dialog',
  templateUrl: './image-cropper-dialog.component.html',
  styleUrls: ['./image-cropper-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ImageCropperDialogComponent implements OnInit, OnDestroy {
  constructor(
    public dialogRef: MatDialogRef<ImageCropperDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: File,
    private ngZone: NgZone,
    private imageCompress: NgxImageCompressService
  ) {}

  ngOnInit(): void {
    const reader = new FileReader();
    reader.onloadend = () => {
      this.cropper?.replace(reader.result as string);
    };
    reader.readAsDataURL(this.data);
  }

  cropper: Cropper | null = null;
  ngAfterViewInit() {
    var image: any = document.getElementById('cropper');
    if (!image) {
      return;
    }
    this.cropper = new Cropper(image, {
      autoCrop: true,
      aspectRatio: 1,
      viewMode: 1,
      minCropBoxWidth: 200,
      minCropBoxHeight: 200,
      cropBoxMovable: false,
      cropBoxResizable: false,
      responsive: true,
      scalable: false,
      rotatable: false,
      dragMode: 'move',
    });
  }

  ngOnDestroy(): void {
    if (this.cropper) {
      this.cropper.destroy();
      this.cropper = null;
    }
  }

  close() {
    this.dialogRef.close();
  }

  loading = false;
  async crop() {
    if (!this.cropper) {
      return;
    }
    this.loading = true;
    const r = this.cropper
      .getCroppedCanvas({ fillColor: '#FFFFFF' })
      .toDataURL('image/jpeg', 100);

    const dataurl = await this.imageCompress.compressFile(
      r,
      0,
      50,
      50,
      200,
      200
    );
    var blob = this.dataURItoBlob(dataurl);
    this.loading = false;
    this.dialogRef.close(blob);
  }

  dataURItoBlob(dataURI: string) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    var ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    var blob = new Blob([ab], { type: mimeString });
    return blob;
  }
}
